// extracted by mini-css-extract-plugin
module.exports = {"settingBox":"KycPersonal_settingBox__wxluw","settingBody":"KycPersonal_settingBody__1ANyu"};